import Vue from 'vue';
import Vuex from 'vuex';

import site from '@/store/site';
import siteModuleName from '@/store/site/moduleName';
import recipe from '@/api/recipe/store';
import recipeModuleName from '@/api/recipe/store/moduleName';
import fileUpload from '@/components/forms/file-upload/store';
import fileUploadModuleName from '@/components/forms/file-upload/store/moduleName';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    [fileUploadModuleName]: fileUpload,
    [siteModuleName]: site,
    [recipeModuleName]: recipe,
  },
});
